import type { ValidationConfig } from '../validationEngine/types';

const whenNotDeleted = (_ctx: any, _value: any, acc: any) => {
    return !acc?.deleted;
};

const minValueRuleBase = {
    type: 'CUSTOM',
    params: {
        evaluator: (value: number, _ctx: any) => {
            return value >= 0;
        }
    },
    messages: 'Must be greater than or equal to 0.00',
    conditions: { when: whenNotDeleted }
} as const;

const maxValueRuleBase = {
    type: 'CUSTOM',
    params: {
        evaluator: (value: number, _ctx: any) => {
            return value < 1_000_000;
        }
    },
    messages: 'Must be less than 1,000,000.00',
    conditions: { when: whenNotDeleted }
} as const;

// Accessory validation config (engine-supported rules only)
// Framework-agnostic for reuse across store and components
export const accessoryValidationConfig: ValidationConfig = {
    name: {
        rules: [
            // TODO: Check if we can use deskingConstants.REQUIRED here after migrating validation engine to shared-ui-utils
            {
                type: 'REQUIRED',
                flow: 'save|contract',
                messages: 'Required',
                conditions: { when: whenNotDeleted }
            },
            {
                type: 'MAX_LENGTH',
                flow: 'contract',
                params: { max: 50 },
                messages: {
                    inline: 'Accessory name cannot be longer than 50 characters.',
                    gcalert: 'name cannot be longer than 50 characters.'
                },
                conditions: { when: whenNotDeleted }
            },
            {
                type: 'MAX_LENGTH',
                params: { max: 256 },
                messages: `Value should be less than 256 symbols.`,
                conditions: { when: whenNotDeleted }
            }
        ]
    },
    cost: {
        rules: [
            {
                type: 'REQUIRED',
                flow: 'save',
                messages: 'Required',
                conditions: { when: whenNotDeleted }
            },
            { ...minValueRuleBase },
            { ...maxValueRuleBase }
        ]
    },
    amount: {
        rules: [
            {
                type: 'REQUIRED',
                messages: 'Required',
                conditions: { when: whenNotDeleted }
            },
            { ...minValueRuleBase },
            { ...maxValueRuleBase }
        ]
    }
};
